// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__3HXSj","log":"ModalInventoryLogs_log__2nZYf","date":"ModalInventoryLogs_date__3oF0n","userName":"ModalInventoryLogs_userName__2a5PS"};